import {baseURL} from "../utilits/config";
import axios from "axios";

export function addClient(clientData, callback){
      const config = {
         method: "post",
         url : baseURL + "/client",
         headers : {
            "Content-Type" : "application/json",
         },
         data : clientData
      }

      axios(config)
           .then((result) =>{
              callback(result.data);
           })
           .catch((error) =>{
              callback(error);
           })
}

export function getClientList(callback){
    const config = {
        method: "get",
        url : baseURL + "/client",
        headers : {
        },
     } 

     axios(config)
           .then((result) =>{
              callback(result.data);
           })
           .catch((error) =>{
              callback(error);
           })
}